module.exports = __webpack_public_path__ + "img/qg2.28b78f61.webp";